// import PropTypes from 'prop-types';

// material-ui
//  import { useTheme } from '@mui/material/styles';
 import wizer from 'assets/images/auth/wizer-logo-brandcolor.png'  
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============ ================== //

const LogoMain = () => {
  // const theme = useTheme();
  return (
    /**
     * if you want to use image instead of svg uncomment following, and comment out <svg> element.
     *
     * <img src={theme.palette.mode === ThemeMode.DARK ? logoDark : logo} alt="icon logo" width="100" />
     *
     */
    <>
      <img src={wizer} alt='Wizer Logo' className='width100px'/> 
     
    </>
  );
};

// LogoMain.propTypes = {
//   reverse: PropTypes.bool
// };

export default LogoMain;
